
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forbesprowatersolutions/book-a-demo",
      function () {
        return require("private-next-pages/forbesprowatersolutions/book-a-demo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forbesprowatersolutions/book-a-demo"])
      });
    }
  